/**
 * Created by BFR on 14/04/2025.
 */
define('productAttachmentsTabController',[
  'module',
  'underscore',
  'app',
  'jquery',
  'productAttachmentsTabView',
  'entities/product_rel'
], function (
  module,
  _,
  App,
  $,
  View
) {

  'use strict';
  module.exports = {

    showDetails: function (region, productModel) {
      var product = App.request('products-rel:model', {secId: productModel.get('secId')});
      this.model = productModel;
      this.region = region;

      var productFetch = product.fetch();

      $.when(productFetch).done(_.bind(function () {
        this.view = new View({
          model: product
        });
        this.view.listenTo(this.view, 'product-attachments:reload', _.bind(this.onReload, this));
        region.show(this.view);
      }, this));
    },

    onReload: function () {
      this.showDetails(this.region, this.model);
    }
  };
});
